import React from "react";
import { Result } from "antd";

function Unauthorized() {
  return (
    <React.Fragment>
      <Result
        status="error"
        title="403"
        subTitle="Seal code is unavailable due to an outdated app version. Please update your app to the latest version to access the seal code or contact support for help."
      />
    </React.Fragment>
  );
}

export default Unauthorized;
